import { Box } from 'rebass'
import styled, { css, withTheme } from 'styled-components'
import { backgroundColor, border, borderColor, borderRadius, display, fontSize, height } from 'styled-system'

import getTestId from '@/utils/getTestId'

const getSizeAttributes = (props) => {
  switch (props.size) {
    case 'sm':
      return {
        height: props.mini ? '30px' : [2, 1]
      }
    case 'large':
      return {
        height: props.mini ? '30px' : [4, 3]
      }
    default:
      return {
        height: props.mini ? '30px' : [3, 2]
      }
  }
}

const StyleableBox = styled(Box)`
  ${border}
  ${borderRadius}
  ${borderColor}
  ${display}
  ${height}
  ${fontSize}
  ${backgroundColor}
`

const NumberPicker = withTheme(({ testId, ...props }) => {
  const mergedProps = { ...props }
  if (mergedProps.inverted) {
    mergedProps.color = undefined
    mergedProps.bg = 'white.default'
    mergedProps.borderColor = 'grey.light'
    mergedProps.backgroundColor = 'white.default'
  }
  const sizeProps = getSizeAttributes(props)

  return (
    <StyleableBox
      {...sizeProps}
      requiredColor='rgba(235, 81, 96, 0.8)'
      as='input'
      type='number'
      data-testid={getTestId(testId, 'input')}
      css={[
        (props) => css`
          &:focus {
            outline: none;
          }
          &::-webkit-inner-spin-button,
          &::-webkit-outer-spin-button {
            opacity: 1;
            -webkit-appearance: none;
            -moz-appearance: none;
            cursor: pointer;
            display: block;
            background: transparent url('./img/arrow-input-number.png') no-repeat;
            ${props.inverted ? 'filter: invert(0.4);' : ''}
            background-position: center left;
            background-size: 22px;
            padding: 4px;
            position: relative;
            right: 0;
            width: 14px;
            height: 35px !important;
            color: white;
            transition: background-color 0.2s ease;
          }
          @media (min-width: ${mergedProps.theme.breakpoints[0]}px) {
            &::-webkit-inner-spin-button,
            &::-webkit-outer-spin-button {
              width: 10px;
              height: 25px !important;
              background-size: 17px;
            }
          }
        `,
        height,
        border,
        borderColor,
        display,
        borderRadius,
        fontSize
      ]}
      {...mergedProps}
    />
  )
})

NumberPicker.defaultProps = {
  color: 'white.default',
  border: 'transparent',
  backgroundColor: 'primaryDark',
  borderColor: 'transparent',
  borderRadius: '4px',
  // fontSize: ['l', 's']
  fontSize: 's',
  inverted: false
}

export default NumberPicker
